import React from "react";

function WithinDistanceInput({ value, onChange }) {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    onChange(inputValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="withinDistanceInput" className="form-label">
        Within Distance
      </label>
      <input type="text" className="form-control" id="withinDistanceInput" value={value} onChange={handleChange} />
    </div>
  );
}

export default WithinDistanceInput;
